import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

type ApiHttpParams = HttpParams | Record<string, string | number | boolean | readonly (string | number | boolean)[]>

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private http = inject(HttpClient)

  get<T = unknown>(url: string, params?: ApiHttpParams): Observable<T> {
    return this.http.get<T>(this.prepareUrl(url), {
      params: params,
      // withCredentials нужно для передачи SSO-cookies
      withCredentials: true,
    })
  }

  post<T = unknown, D = unknown>(url: string, data: D, params?: ApiHttpParams): Observable<T> {
    return this.http.post<T>(this.prepareUrl(url), data, {
      params,
      // withCredentials нужно для передачи SSO-cookies
      withCredentials: true,
    })
  }

  private prepareUrl(url: string) {
    if (url.startsWith('https:') || url.startsWith('http:')) {
      return url
    }
    return environment.api.url.replace(/\/$/, '') + '/' + url.replace(/^\//, '')
  }

}
